import styled from 'styled-components'
import { grayText, white, black } from 'theme/colors'

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 100px);
`

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${white};
  margin-left: 9px;
  overflow: scroll;
  height: 58vh;
  width: 100%;
  justify-content: center;
  table {
    width: 92%;
    border-collapse: collapse;
    background-color: transparent;
  }
  th,
  td {
    text-align: left;
    padding-left: 30px;
  }
`

export const ActivityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 60px;
`

export const ActivityText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${black};
  text-align: left;
`

export const CustomText = styled.div`
  font-size: 14px;
  color: ${black};
  font-weight: 500;
  text-align: left;
  margin: 0;
`

export const DebinCardsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 0 24px 24px;
  margin-left: 9px;
  max-width: calc(100vw - 280px);
  width: 100%;
  min-width: 0;
`

export const CardsCarousel = styled.div`
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 24px;
  width: 100%;
  min-width: 0;
  padding-right: 24px;
  cursor: grab;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const NoActiveCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 60px 0 70px 0;

  p {
    font-size: 1rem;
    color: ${grayText};
    text-align: center;
    margin: 0;
    opacity: 1;
  }
`

export const NoActiveCardsTitle = styled.h2`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  color: ${black};
  margin: 0;
`

export const DebinCardsSectionTitle = styled.h2`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  color: ${black};
  margin: 0;
`

export const TitleWithTooltip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  width: 100%;
  min-height: 400px;
  padding: 2rem;

  p {
    width: 203px;
    height: 50px;
    font-size: 1rem;
    color: ${grayText};
    text-align: center;
    margin: 0;
    opacity: 1;
  }
`
